import "./index.css";
import App from "./App";
import React, { Suspense } from "react";
import { render } from "react-dom";
import Spinner from "./components/UI/NvidiaSpinner/NvidiaSpinner";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";

console.log(`Consent Signup v${APP_VERSION}`);

render(
  <I18nextProvider i18n={i18n}>
    <Suspense fallback={<Spinner />}>
      <App />
    </Suspense>
  </I18nextProvider>,
  document.querySelector("#root")
);
